import React from "react";
import { useSelector } from "react-redux";

const LoaderOverlay = () => {
  const loader = useSelector(state => state.loader.loader); // Get loader state from Redux
  console.log('loader',loader)
  if (!loader) return null; // Hide if not loading

  return (
      <div className="preloader">
        <img src="/assets/images/logo/logo.png" alt="" width="300" />
      </div>
  );
};

// Styles for loader
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  spinner: {
    width: "4rem",
    height: "4rem",
    color: "#FB8500"
  }
};

export default LoaderOverlay;
